(() => {
  if (window.gdxInlineReviews) return;
  window.gdxInlineReviews = true;
  const videos = new Set();
  const pauseOthers = active => videos.forEach(video => { if (video !== active) video.pause(); });
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.intersectionRatio < .2) entry.target.pause();
  }, {threshold: [0, .2]}) : null;
  document.addEventListener('click', event => {
    const button = event.target.closest('.fx-reviews .gdx-review-play');
    if (!button) return;
    const card = button.closest('[data-video-url]'), holder = button.closest('.vid');
    if (!card || !holder) return;
    let video = holder.querySelector('video');
    if (!video) {
      video = document.createElement('video');
      video.controls = true; video.playsInline = true; video.preload = 'none';
      video.setAttribute('playsinline', ''); video.setAttribute('aria-label', button.getAttribute('aria-label'));
      video.poster = holder.querySelector('img')?.currentSrc || '';
      video.src = card.dataset.videoUrl;
      video.addEventListener('play', () => pauseOthers(video));
      video.addEventListener('error', () => { button.hidden = false; video.hidden = true; });
      videos.add(video); observer?.observe(video); holder.append(video);
    }
    pauseOthers(video); button.hidden = true; video.hidden = false;
    const playing = video.play();
    playing?.catch(() => { button.hidden = false; video.hidden = true; });
  });
  document.addEventListener('visibilitychange', () => { if (document.hidden) pauseOthers(); });
  document.addEventListener('shopify:section:unload', event => {
    for (const video of videos) if (event.target.contains(video)) {video.pause();observer?.unobserve(video);videos.delete(video);}
  });
})();
